import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { Dashboard } from './pages/Dashboard';
import { MartesPage } from './pages/MartesPage';
import { YtMartesPage } from './pages/YtMartesPage';
import { YtJuevesPage } from './pages/YtJuevesPage';
import { OrganicJuevesPage } from './pages/OrganicJuevesPage';
import { OrganicMartesPage } from './pages/OrganicMartesPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-19">
      <Routes data-id="element-20">
        <Route path="/meta-jueves" element={<App data-id="element-22" />} data-id="element-21" />
        <Route path="/dash" element={<Dashboard data-id="element-24" />} data-id="element-23" />
        <Route path="/meta-martes" element={<MartesPage data-id="element-26" />} data-id="element-25" />
        <Route path="/yt-martes" element={<YtMartesPage data-id="element-28" />} data-id="element-27" />
        <Route path="/yt-jueves-cp" element={<YtJuevesPage data-id="element-30" />} data-id="element-29" />
        <Route path="/organic-jueves" element={<OrganicJuevesPage data-id="element-32" />} data-id="element-31" />
        <Route path="/organic-martes" element={<OrganicMartesPage data-id="element-34" />} data-id="element-33" />
      </Routes>
    </BrowserRouter>;
}